import {
  Node,
  Edge,
  MarkerType
} from "react-flow-renderer";
import { Branch, InterviewNode } from "../../../../../../CandidatePortal/scenes/Interview/Chatbot/interface";

const position = { x: 0, y: 0 };
const edge = {
  type: 'floating', // floating or simplebezier
  animated: false,
  markerEnd: {
    type: MarkerType.ArrowClosed
  }
};

const NodeElements = (intents: InterviewNode[]) => {
  const nodes: Node[] = [];
  const edges: Edge[] = [];

  intents.forEach((intent: InterviewNode) => {
    nodes.push({
      id: intent.name,
      data: {
        label: intent.name
      },
      position: !!intent.position ? intent.position : position
    });

    if (!intent.isLastQuestion)
      switch (intent.typeOfQuestion) {
        case 'DelegatedQuestion':
          if (intent.nextStep) {
            edges.push({
              id: intent.name + 'delegate',
              source: intent.name,
              target: intent.nextStep,
              ...edge
            });
          }
          break;
        case 'OpenEndedQuestion':
          if (intent.nextStep)
            edges.push({
              id: intent.name + 'delegate',
              source: intent.name,
              target: intent.nextStep,
              ...edge
            });
          break;
        case 'ConfirmationQuestion':
          if (intent.confirmationSetting) {
            if (intent.confirmationSetting.flowToIfYes && intent.confirmationSetting.flowToIfYes.length > 0)
              edges.push({
                id: intent.name + 'yes',
                label: 'Yes',
                source: intent.name,
                target: intent.confirmationSetting.flowToIfYes,
                ...edge
              });
            if (intent.confirmationSetting.flowToIfNo && intent.confirmationSetting.flowToIfNo.length > 0)
              edges.push({
                id: intent.name + 'no',
                label: 'No',
                source: intent.name,
                target: intent.confirmationSetting.flowToIfNo,
                ...edge
              });
          }
          break;
        case 'ConditionalQuestion':
          if (intent.conditionalSetting) {
            if (intent.conditionalSetting.branches && intent.conditionalSetting.branches.length > 0) {
              intent.conditionalSetting.branches.forEach((branch: Branch, index: number) => {
                if (branch.nextStep && branch.nextStep.length > 0)
                  edges.push({
                    id: `${intent.name} ${index} ${branch.name} ${branch.nextStep}`,
                    label: branch.name,
                    source: intent.name,
                    target: branch.nextStep,
                    ...edge
                  });
              });
            }
            if (intent.conditionalSetting.defaultStep && intent.conditionalSetting.defaultStep.length > 0)
              edges.push({
                id: intent.name + 'default',
                label: 'default',
                source: intent.name,
                target: intent.conditionalSetting.defaultStep,
                ...edge
              })
          }
          break;
      }
  });

  return { nodes, edges };
}

export default NodeElements